import React from 'react';
import { connect } from 'react-redux';
import { Nav, NavItem } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { forEach as _forEach, findIndex as _findIndex, find as _find } from 'lodash';

import * as CmsSettingsComponents from 'components/cms/settings/elements';

import CmsCommonSettings from './CmsCommonSettings';
import CmsStyleSettings from './CmsStyleSettings';
import CmsEffectsSettings from './CmsEffectsSettings';
import CmsRemoveElement from './CmsRemoveElement';

class CmsElementSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activeNav: 1,
    };
  }

  getComponentName = componentType => {
    const componentName = ('CmsElement_' + componentType.toLowerCase()).replace(/_([a-z])/g, g => {
      return g[1].toUpperCase();
    });
    return componentName;
  };

  getComponentByName = name => {
    if (CmsSettingsComponents[name] !== undefined) {
      return CmsSettingsComponents[name];
    }

    return 'div';
  };

  close = () => {
    const { close } = this.props;
    close();
  };

  handleNav = activeNav => {
    this.setState({ activeNav });
  };

  setParams = paramList => {
    const { index, entity, changeEntity, element } = this.props;
    const params = element.getParams().slice();

    const treeIndex = index.toString().split('.');
    const tree = [];

    for (let i = 0; i < treeIndex.length; i++) {
      tree.push(i === 0 ? 'content' : 'children');
      tree.push(treeIndex[i]);
    }

    _forEach(paramList, ({ name, value }) => {
      const paramIndex = _findIndex(params, ['name', name]);
      const paramValue = entity.createValue('params', tree, { name, value });
      if (paramIndex >= 0) {
        // parameter was found
        params[paramIndex] = paramValue;
      } else {
        // parameter was not found, append the parameter with its value
        params.push(paramValue);
      }
    });

    const newEntity = { ...entity.updateValue('params', params, tree) };

    changeEntity(newEntity);
  };

  setParam = (name, value) => {
    this.setParams([{ name, value }]);
  };

  getParam = name => {
    const { element } = this.props;
    return _find(element.getParams(), ['name', name]);
  };

  getParamValue = (name, defaultValue = null) => {
    const param = this.getParam(name);
    if (param) {
      return param.value;
    }

    return defaultValue;
  };

  getSettingsComponentProps = () => {
    const {
      intl,
      appIntl,
      element,
      entity,
      changeEntity,
      index,
      navigateSettings,
      addElement,
      removeElement,
      reorderElements,
      pageId,
      itemId,
    } = this.props;
    return {
      intl,
      appIntl,
      element,
      entity,
      changeEntity,
      index,
      navigateSettings,
      addElement,
      removeElement,
      reorderElements,
      pageId,
      itemId,
      setParam: this.setParam,
      setParams: this.setParams,
      getParam: this.getParam,
      getParamValue: this.getParamValue,
    };
  };

  componentDidUpdate = prevProps => {
    const { index, element } = this.props;

    if (prevProps.index !== index) {
      this.setState({ activeNav: 1 });
    }

    if (prevProps.element && !element) {
      this.close();
    }
  };

  getParentInfo = () => {
    const { index } = this.props;
    const treeIndex = index.toString().split('.');
    const parentTreeIndex = treeIndex.slice(0, treeIndex.length - 1);

    return { treeIndex, parentTreeIndex };
  };

  removeElement = e => {
    const { removeElement, navigateSettings, index } = this.props;
    const { treeIndex, parentTreeIndex } = this.getParentInfo();
    if (treeIndex.length > 4) {
      // remove element and navigate to parent
      removeElement(index, false, () => navigateSettings(e, parentTreeIndex.join('.')));
    } else {
      // remove element and close settings
      removeElement(index);
    }
  };

  navigateBack = e => {
    e.preventDefault();

    const { navigateSettings } = this.props;
    const { parentTreeIndex } = this.getParentInfo();

    navigateSettings(e, parentTreeIndex.join('.'));
  };

  // check if the design tab should be displayed
  isDesignDisabled = () => {
    const { element } = this.props;

    if (element === null || element === undefined) {
      return false;
    }

    if (element.getType() === 'dynamic_element') {
      return true;
    }

    return false;
  };

  // check if the responsive tab should be displayed
  isResponsiveDisabled = () => {
    const { element } = this.props;

    if (element === null || element === undefined) {
      return false;
    }

    if (element && element.getType() === 'dynamic_element') {
      return true;
    }

    return false;
  };

  // check if the animation tab should be displayed
  isAnimationDisabled = () => {
    const { element } = this.props;

    if (element === null || element === undefined) {
      return false;
    }

    if (element && element.getType() === 'dynamic_element') {
      return true;
    }

    return false;
  };

  render() {
    const {
      intl: { messages },
      element,
      open,
      close,
      index,
    } = this.props;
    const { activeNav } = this.state;

    const hasElement = element !== null && element !== undefined;
    const RenderSettingsComponent = hasElement
      ? this.getComponentByName(this.getComponentName(element.getType()))
      : null;
    const settingsComponentProps = this.getSettingsComponentProps();

    return (
      <div className={open ? '' : 'hide'}>
        <Nav
          bsStyle="tabs"
          activeKey={activeNav}
          onSelect={this.handleNav}
          className="p-l-0 p-r-0 p-b-5 bg-master text-white"
        >
          <NavItem eventKey={1}>Element</NavItem>
          {!this.isDesignDisabled() && <NavItem eventKey={2}>{messages.design}</NavItem>}
          {!this.isResponsiveDisabled() && <NavItem eventKey={3}>{messages.settings}</NavItem>}
          {!this.isAnimationDisabled() && <NavItem eventKey={4}>Effects</NavItem>}
        </Nav>
        <a href="#close" className="close btn-link quickview-toggle pull-right text-white" onClick={close}>
          <span>×</span>
        </a>

        {hasElement && (
          <div className="padding-10" key={index}>
            <div className="panel panel-transparent">
              {activeNav === 1 && (
                <>
                  <RenderSettingsComponent {...this.getSettingsComponentProps()} navigateBack={this.navigateBack} />

                  <CmsRemoveElement onSuccess={this.removeElement} />
                </>
              )}

              {activeNav === 2 && <CmsStyleSettings {...settingsComponentProps} />}

              {activeNav === 3 && <CmsCommonSettings {...settingsComponentProps} />}

              {activeNav === 4 && <CmsEffectsSettings {...settingsComponentProps} />}
            </div>
          </div>
        )}
      </div>
    );
  }
}
CmsElementSettings.defaultProps = {
  close: () => {},
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    layout: state.layout,
  };
};

export default injectIntl(connect(mapStateToProps)(CmsElementSettings));
